import * as actionTypes from '../actions/actionTypes';
const initialState = {
  settings: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/setting.js